import React from 'react';
import { createUseStyles } from 'react-jss';

// style =====================================

const useStyles = createUseStyles({
  header: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  section: {
    width: '100%',
    position: 'relative',
    zIndex: 0,
  },
});

// component =================================

type Props = {
  children: React.ReactNode;
  renderHeader: () => React.ReactNode;
};

const StickySection = (props: Props) => {
  const { children, renderHeader } = props;
  const classes = useStyles();

  return (
    <li>
      <div className={classes.header}>{renderHeader()}</div>
      <div className={classes.section}>{children}</div>
    </li>
  );
};

export default StickySection;
